import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
    TextField,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
} from '@mui/material';
import { Category as ServiceIcon } from '@mui/icons-material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const schema = yup.object().shape({
    tipsernom: yup
        .string()
        .trim()
        .required('El nombre es obligatorio')
        .max(150, 'Máximo 150 caracteres'),
    tipserdes: yup
        .string()
        .nullable()
        .max(500, 'Máximo 500 caracteres'),
});

const ServicesTypeForm = ({ open, handleClose, onSubmit, defaultValues = {} }) => {
    const isEditing = Boolean(defaultValues?.tipserid);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            tipsernom: '',
            tipserdes: '',
        },
    });

    useEffect(() => {
        if (open) {
            reset({
                tipsernom: defaultValues?.tipsernom || '',
                tipserdes: defaultValues?.tipserdes || '',
            });
        }
    }, [open, defaultValues, reset]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{ sx: { borderRadius: 2 } }}
        >
            <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
                <ServiceIcon color="primary" />
                {isEditing ? 'Editar Tipo de Servicio' : 'Nuevo Tipo de Servicio'}
            </DialogTitle>

            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent dividers sx={{ bgcolor: '#fbfbfb' }}>
                    <Stack spacing={3}>
                        <TextField
                            label="Nombre del tipo de servicio"
                            fullWidth
                            {...register('tipsernom')}
                            error={!!errors.tipsernom}
                            helperText={errors.tipsernom?.message}
                            placeholder="Ej: SERVICIO DE TRANSPORTE DE PERSONAL"
                            autoFocus
                        />

                        <TextField
                            label="Descripción"
                            fullWidth
                            multiline
                            rows={3}
                            {...register('tipserdes')}
                            error={!!errors.tipserdes}
                            helperText={errors.tipserdes?.message}
                            placeholder="Descripción general del tipo de servicio"
                        />
                    </Stack>
                </DialogContent>

                <DialogActions sx={{ p: 2.5, bgcolor: '#fbfbfb' }}>
                    <Button onClick={handleClose} color="inherit" variant="outlined">
                        Cancelar
                    </Button>

                    <Button
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting}
                        disableElevation
                    >
                        {isEditing ? 'Actualizar' : 'Guardar'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ServicesTypeForm;